import React, { useState, useEffect} from 'react';
import { useTranslation, Trans } from 'react-i18next'; 

import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
//import { useData } from '../contexts/DataContext'; 
import { useAppData } from "../hooks/useAppData";
import { useAppStore } from "../hooks/useAppStore"; 
import { useUserData } from "../hooks/useUserData";
import { useUserStore } from "../hooks/useUserStore"; 


import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import '../styles/App.css';

import TurnstileWidget from '../components/Widget/TurnstileWidget';

const SessionTimeoutOverlay = ({onClose}) => {
  const { t } = useTranslation(); 

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [turnstileTokenStatus, setTurnstileTokenStatus] = useState(''); // Track Turnstile status
  
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [submitError, setSubmitError] = useState('');

  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  /*const { setWordListId, setSoundboardId } = useData();*/
  const { 
      wordListId, setWordListId, 
      soundboardId, setSoundboardId,
      stageWidth, setStageWidth,
      stageHeight, setStageHeight,
      buttonPopovers, setButtonPopovers,
      shapePopovers, setShapePopovers,
      selectedItem, setSelectedItem,
      wordListWidth, setWordListWidth
  } = useAppStore();

  const { loginUser } = useUserData();
  const { isSessionTimedOut, setIsSessionTimedOut } = useUserStore();


  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError('');
    setPasswordError('');
    setSubmitError('');
  
    if (!email || !password) {
      if (!email) setEmailError(t('errors.emailRequired'));
      if (!password) setPasswordError(t('errors.passwordRequired'));
      return;
    }
  
    if (emailError) return;
  
    setLoading(true);

    loginUser.mutate(
      { email, password },
      {
        onSuccess: () => {
          setIsSessionTimedOut(false);
          navigate('/MainContent');
        },
        onError: (error) => {
          if (error?.response?.status === 404) {
            setSubmitError(
              <Trans
                i18nKey="errors.emailNotRegistered"
                components={{
                  1: <Link to={`/register?email=${encodeURIComponent(email)}`} className="register-link">register for a new account</Link>,
                }}
              />
            );
          } else if (error?.response?.status === 401) {
            setSubmitError(t('errors.credentialsFailed'));
          } else {
            setSubmitError(t('errors.loginFailed'));
          }
        },
        onSettled: () => setLoading(false),
      }
    );

    /*try {
      const response = await axios.post(`${baseURL}/api/users/login`, { email, password });
      const { accessToken, wordListId, soundboardId } = response.data;

      localStorage.setItem('userToken', accessToken);
      setWordListId(wordListId);
      setSoundboardId(soundboardId);

      navigate('/MainContent');
      onClose();
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setSubmitError(
          <>
            <Trans i18nKey="errors.emailNotRegistered"
              components={{
                1: <Link to={`/register?email=${encodeURIComponent(email)}`} className="register-link">register for a new account</Link>,
              }}
            />
          </>
        );
      } else if (error.response && error.response.status === 401) {
        setSubmitError(t('errors.credentialsFailed'));
      } else {
        setSubmitError(t('errors.loginFailed'));
      }
      setEmailError(''); // Clear specific errors if any
      setPasswordError('');
      setEmail(email); // Reset email to trigger re-validation
      setPassword(password); // Reset password to trigger re-validation
    } finally {
      setLoading(false);
    }*/
  };
  
    useEffect(() => {
      const timer = setTimeout(() => {
        if (email && !validateEmail(email)) {
          setEmailError(t('errors.invalidEmail'));
        } else {
          setEmailError('');
        }
      }, 500);
  
      return () => clearTimeout(timer);
    }, [email]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (email && !validateEmail(email)) {
        setEmailError(t('errors.invalidEmail'));
      } else {
        setEmailError('');
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [email]);
  

  return (
    <div className="session-timeout-overlay">
      <div className="session-timeout-content">
        <p className="session-timeout-message">{t('sessionExpired.sessionExpiredText')}</p>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          {submitError && (
            <div className="general-error-message">
              <ErrorOutlineIcon className="feedback-icon" />
              {submitError}
            </div>
          )}
          <div className="text-field-wrapper">
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label={t('common.emailLabel')}
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError('');
                setSubmitError('');
              }}
              error={Boolean(emailError) || Boolean(submitError)}
              helperText={emailError}
            />
          </div>
          <div className="text-field-wrapper">
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label={t('common.passwordLabel')}
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError('');
                setSubmitError('');
              }}
              error={Boolean(passwordError) || Boolean(submitError)}
              helperText={passwordError}
            />
          </div>
          <div className="text-field-wrapper">
            
            <TurnstileWidget setTurnstileTokenStatus={setTurnstileTokenStatus} />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading || turnstileTokenStatus !== "solved"}
              sx={{ 
                mt: 2, 
                mb: 2,     
                alignSelf: 'center', // Ensure the button itself is centered within its parent
              }}
            >
              {loading ? t('common.loggingInLabel') : t('common.loginLabel')}
            </Button>
          </div>
        </Box>

      </div>
    </div>
  );
};

export default SessionTimeoutOverlay;
